import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { styles } from "./Weather.style";

import "./LitWeather";
import { watch } from "../internal/watch";
import { reverseGeocode } from "../../Geocode";
import { DisplayUnits } from "../../../models";

@customElement("ds-weather")
export class Weather extends BaseElement {
    static override styles = [
        styles,
        css`
            :host {
                display: block;
            }
        `,
    ];

    @property({ type: Number }) lat = 0;
    @property({ type: Number }) lon = 0;
    @property({ type: Boolean }) showLocationText = false;
    @state() protected _units: "Imperial" | "Metric" = "Metric";
    @state() protected _locationText = "";

    @watch("lat")
    @watch("lon")
    async _locationChange(_oldValue: any, _newValue: any) {
        if (this.showLocationText) {
            const addr = await reverseGeocode({ lat: this.lat, lon: this.lon });
            if (addr) {
                this._locationText =
                    `${addr.suburb ? addr.suburb : ""}` + (addr.state ? `, ${addr.state}` : ``);
            }
        }
    }

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        const units = this._kernel.currentUserSettings.get().displayUnits;
        this._units = units === DisplayUnits.METRIC ? "Metric" : "Imperial";
    }

    override render() {
        return html`<div>
            <ds-lit-weather
                token="1e366c8dec8ecdfd589dd13d8aa454e2"
                .units=${this._units}
                .lat=${this.lat}
                .lon=${this.lon}
                .locationText=${this.showLocationText ? this._locationText : ""}
                iconBaseUrl="/assets/weather-icons"
            ></ds-lit-weather>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-weather": Weather;
    }
}
